<template>
  <!-- :style="{ marginTop: tips == '' ? '50px' : '33px' }" -->
  <!-- :style="{ marginTop: tips == '' ? '30px' : '16px' }" -->
  <div class="signinCode" :style="{ marginTop: tips == '' ? '30px' : '30px' }">
    <el-form
      ref="phoneForm"
      :model="phoneForm"
      :rules="phoneRules"
      auto-complete="on"
      label-position="left"
    >
    <!-- placeholder="请输入登录韵镖侠的手机号" -->
      <el-form-item prop="mobile">
        <div class="phone_box">
          <el-input
            ref="phone"
            v-model.trim="phoneForm.mobile"
            :placeholder="loginTab == '1' ? '请输入手机号' : '请输入登录韵镖侠的手机号'"
            name="phone"
            maxlength="11"
            tabindex="1"
            auto-complete="on"
            clearable
            @blur="phoneForm.mobile = $event.target.value"
          >
            <i slot="prefix" class="left_phone">
              <span>+86</span>
              <span class="el-icon-arrow-down" />
              <span class="line" />
            </i>
          </el-input>
        </div>
      </el-form-item>

      <el-form-item prop="sms_code">
        <div class="code_input">
          <el-input
            v-model.trim="phoneForm.sms_code"
            placeholder="请输入验证码"
            name="Code"
            maxlength="6"
            oninput="value=value.replace(/[^\d.]/g,'')"
            @blur="phoneForm.sms_code = $event.target.value"
            @keyup.enter.native="
              phoneForm.sms_code = $event.target.value;
              login();
            "
          >
            <span slot="prefix" class="codeSMS">
              <!-- <svg-icon icon-class="code-SMS" /> -->
            </span>
            <div slot="suffix" class="codeTxt">
              <!-- <div class="code_line" /> -->
              <div class="code" @click="getCode">{{ getSendBtnText }}</div>
            </div>
          </el-input>
        </div>
      </el-form-item>
      <div class="tips" v-html="tips"></div>
      <el-button size="mini" @click="login">登录</el-button>
    </el-form>
    <div class="login-alert" v-if="loginTab == '1'">未注册用户，登录默认注册韵商宝会员</div>
    <div v-if="isShowImgCode">
      <Verify
        v-show="isShowImgCode"
        :mode="'pop'"     
        :captchaType="'blockPuzzle'"    
        :imgSize="{ width: '330px', height: '155px' }" 
        ref="verify"
        @success="verifySuccess" 
      ></Verify>
    </div>
  </div>
</template>

<script>
import home from "@/api/home";
import util from "@/util/util";
import Verify from '@/components/verifition/Verify' 
const isPhoneNumber = new RegExp(/^[1]([3-9])[0-9]{9}$/);
// /^1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/g;
export default {
  name: "LoginCode",
  props: {
    loginTab: {
      required: true,
      type: String,
    },
  },
  components: {
    Verify
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!isPhoneNumber.test(value)) {
        callback(new Error("请填写正确的手机号"));
        return;
      } else {
        callback();
      }
    };
    return {
      phoneForm: {
        mobile: "",
        sms_code: "",
      },
      phoneRules: {
        mobile: [
          { required: true, trigger: "blur", validator: validateMobile },
        ],
        sms_code: [
          { required: true, trigger: "blur", message: "请填写短信验证码" },
        ],
      },
      countNum: 0,
      countInterval: null,
      throttleFlag: true,
      tips: "",
      getSendBtnText: "获取验证码",
      isShowImgCode: false, // 是否展示图形验证码
    };
  },
  // computed: {
  //   getSendBtnText() {
  //     if (this.countNum > 0 && this.phoneForm.Mobile.length > 0) {
  //       return this.countNum + "秒后重新获取";
  //     } else {
  //       return "获取验证码";
  //     }
  //   },
  // },
  beforeDestroy() {
    if (this.countInterval) {
      clearInterval(this.countInterval);
    }
  },
  methods: {
    getCode() {
      let that = this 
      if (!this.phoneForm.mobile || this.phoneForm.mobile.length == 0) {
        this.$message.warning("请输入手机号");
        return false;
      }
      if (!isPhoneNumber.test(this.phoneForm.mobile)) {
        this.$message.warning("请输入正确的手机号");
        return false;
      }
      if (!this.throttleFlag || this.getSendBtnText != "获取验证码") return;
      this.throttleFlag = false;
      
      this.isShowImgCode = true
      that.$nextTick(()=>{ 
        that.useVerify()
      })   
    },
    startTimer(param) {
      let _this = this;
      _this.countInterval = setInterval(() => {
        _this.countNum--;
        if (_this.countNum > 0) {
          _this.getSendBtnText =
            _this.countNum + (param > 1000 ? "分钟" : "秒") + "后重新获取";
        } else if (_this.countNum <= 0) {
          _this.getSendBtnText = "获取验证码";

          clearInterval(_this.countInterval);
        }
      }, param);
    },
    jgenv() {
      let redirect_uri = "";
      if (util.jgEnv() == 'pro') {
        // 生产环境
        redirect_uri = "https://ysbywy.yundasys.com";
      } else {
        // 开发环境
        redirect_uri = "http://10.172.17.136:10086";
        // redirect_uri = "http://10.20.133.192:9527";
      }
      return redirect_uri;
    },
    login() {
      let _this = this;
      // window.location.href = _this.jgenv() + "?token=CNLGgEjKFAgAuAtCDGjAGmio&websocket_token=2d2810d435bcd64b40b1ec2668ef456e&appKey=123456";
      this.$refs.phoneForm.validate((valid) => {
        if (valid) {
          // alert("submit!");
          // _this.$router.push("/");
          if (_this.loginTab == '1') {
            _this.ysbLoginReq()
          } else {
            _this.courierLoginReq()
          }

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 图形验证码方法
    verifySuccess(params){
      if (this.loginTab == '1') {
        this.ysbGetCodeReq(params.captchaVerification)
      } else {
        this.courierGetCodeReq()
      }
    },
    useVerify(){
      this.$refs.verify.show()
    },
    // 韵商宝获取验证码
    ysbGetCodeReq(captchaVerification) {
      let that = this 
      let data = {
        sms_type: 'login',
        phone: that.phoneForm.mobile,
        captcha: captchaVerification,
        captcha_type: 'blockPuzzle'
      }
      home.ysbGetCode(this, data).then(res => {
        this.throttleFlag = true;
        if (res.data.code == 200 && res.success) {
          if (res.data.data != 0) {
            this.tips =
              "验证码已发送，请耐心等待，10分钟内有效，1小时内还有" +
              "<i>" +
              res.data.data +
              "</i>" +
              "次获取验证码机会";
          } else {
            // let time = new Date().getHours();
            // time = time + 1 == 25 ? 1 : time + 1;
            // this.tips =
            //   "<i>" +
            //   "此手机号已超过每小时获取次数，" +
            //   time +
            //   "点后再重新获取验证码" +
            //   "</i>";
          }
          this.countNum = 60;
          this.getSendBtnText = "60秒后重新获取";
          this.startTimer(1000);
        } 
      }).catch((e) => {
        // debugger;
        // this.$message.warning(e.remark);
        this.throttleFlag = true;
      });
    },
    // 快递员获取验证码
    courierGetCodeReq() {
      home
        .getSmsCode(this)
        .then((res) => {
          this.throttleFlag = true;
          // this.$message.warning(res.message);
          if (res.data.code == 200 && res.success) {
            //是业务员
            if (res.data.data != 0) {
              this.tips =
                "验证码已发送，请耐心等待，10分钟内有效，1小时内还有" +
                "<i>" +
                res.data.data +
                "</i>" +
                "次获取验证码机会";
            } else {
              let time = new Date().getHours();
              time = time + 1 == 25 ? 1 : time + 1;
              this.tips =
                "<i>" +
                "此手机号已超过每小时获取次数，" +
                time +
                "点后再重新获取验证码" +
                "</i>";
            }
            this.countNum = 60;
            this.getSendBtnText = "60秒后重新获取";
            this.startTimer(1000);
          } else {
            //不是业务员
            // 请输入快递员手机号
            alert(222);
          }
        })
        .catch((e) => {
          // debugger;
          // this.$message.warning(e.remark);
          this.throttleFlag = true;
        });
    },
    // 韵商宝登录
    ysbLoginReq() {
      let _this = this 
      home.accountLogin(this, false).then((res) => {
        if (res.data.code == 200 && res.success) {
          util.setCookie("account_id", res.data.data.account_id);
          util.setCookie("token", res.data.token);
          util.setCookie(
            "websocket_token",
            res.data.data.websocket_token
          );
          util.setCookie("app_key", res.data.data.app_key);
          util.setCookie("nickname", res.data.data.nickname);
          util.setCookie("headimgurl", res.data.data.headimgurl);
          // debugger;
          _this.$router.push("/loading");

        }else if(res.data.code == 8018){     
          this.$message({
            message:
              "该账号已锁定，请先使用微信扫码登录，或于一小时后重新尝试",
            type: "warning",
          });              
        }else{
          this.$message.error('登录失败')
        }
      });
    },
    // 快递员登录
    courierLoginReq() {
      let _this = this 
      home.staffLogin(this).then((res) => {
        // debugger;
        if (res.data.code == 200 && res.success) {
          const websocketToken = res.data.data.websocket_token;
          const appKey = res.data.data.app_key;
          const accoundId = res.data.data.account_id;
          window.location.href =
            _this.jgenv() +
            "?token=" +
            res.data.token +
            "&websocket_token=" +
            websocketToken +
            "&appKey=" +
            appKey +
            "&account_id=" +
            accoundId;
        }else{
          this.$message.error('登录失败')
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.signinCode {
  margin: 50px auto 15px;
  width: 360px;
  // width: 299px
  .phone_box {
    ::v-deep .el-input--prefix .el-input__inner {
      padding-left: 55px;
    }
  }
  .code_input {
    ::v-deep .el-input--suffix .el-input__inner {
      padding-right: 85px;
    }
    .svg-icon {
      fill: #c0c4cc;
      width: 24px;
      height: 24px;
      vertical-align: -8px;
    }
  }
.tips{
  font-size:12px;
  // margin-top: -11px;
  margin-top: -4px;
  ::v-deep i{
    color: #F56C6C;
    font-style:normal
  }
}
  .line {
    height: 20px;
    border: 1px solid #dcdfe6;
    margin: 0 5px;
  }
  .code_line {
    width: 0px;
    height: 20px;
    border: 1px solid #dcdfe6;
    margin: 0 10px;
  }
  .code {
    cursor: pointer;
    // background: #1b72e9;
    background: #409EF2;
    color: #fff;
    padding: 0 10px;
  }
  /deep/.el-input__suffix{
    right: 0
  }
  .codeTxt{
    display: flex;
    align-items: center;
    border-radius:0 4px 4px 0;
    overflow: hidden;
  }
  /deep/.el-form-item {
    // margin-bottom: 33px;
    margin-bottom: 20px;
  }
  /deep/button{
    width 100%;
    // background: #1b72e9;
    background: #409EF2;
    color: #fff;
    height: 48px;
    // margin-top: 20px;
    margin-top: 45px;
    font-size: 16px;
    font-weight: 500;
    font-family: "PingFang SC";
  }
  .login-alert {
    margin-top: 14px;
    color: #888888;
    font-size: 12px;
    font-weight: 400;
    height: 36px;
  }
}
</style>
